<script setup lang="ts">
  import { computed } from 'vue'

  import { EditorContent as TiptapEditorContent } from '@tiptap/vue-3'

  import { createElementId } from '@common/core-layer/utils'

  import { useEditor } from './composables/useEditor'

  const props = defineProps({
    className: { type: String, default: '' },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  })

  const { editor } = useEditor()

  // ID should be 'edit' when replying or editing, 'main' for new comments
  const contentId = computed(() => {
    return props.isEditMode ? 'edit' : 'main'
  })
</script>

<template>
  <TiptapEditorContent
    v-if="editor"
    :id="createElementId('editor', 'content', contentId)"
    :editor="editor"
    class="max-h-[200px] min-h-[32px] overflow-y-auto"
    :class="props.className"
  />
</template>
<style scoped>
  :deep(.tiptap.ProseMirror > p) {
    margin-top: 0;
  }
</style>
